export default __webpack_public_path__ + "static/media/logo.64985b84.png";